import { Form, Input, Button, Card } from "antd";
import {
  MailOutlined,
  PhoneOutlined,
  WhatsAppOutlined,
  EnvironmentOutlined,
} from "@ant-design/icons";
import "./ContactUs.css";

export default function ContactUs() {
  const [form] = Form.useForm();

  const onFinish = (values) => {
    console.log("Form Submitted:", values);
  };

  const openGoogleMaps = () => {
    window.open(
      "https://www.google.com/maps?rlz=1C5CHFA_enIN1098IN1098&gs_lcrp=EgZjaHJvbWUyBggAEEUYOTIJCAEQIRgKGKABMgkIAhAhGAoYoAEyBwgDECEYjwLSAQg4Mzc1ajBqN6gCALACAA&um=1&ie=UTF-8&fb=1&gl=in&sa=X&geocode=Kd2AsDSscws5MRDUYGbOD7FC&daddr=hasanpur+road,+Gajraula,+Vill,+Manota,+Gajraula,+Uttar+Pradesh+244241"
    );
  };

  return (
    <div className="contact-container">

      {/* 🌿 Centered Page Title */}
      <h1 className="contact-page-title">Contact Us</h1>

      <div className="contact-row">
        {/* Left Side: Contact Information */}
        <Card className="contact-info-card">
          <h2 className="contact-title">Contact Information</h2>

          <div className="contact-info-grid">
            {/* Address */}
            <div className="contact-box" onClick={openGoogleMaps}>
              <EnvironmentOutlined className="icon" />
              <h3>Address</h3>
              <p>
                Garvana, Vill - Manota, Hasanpur Road, Gajraula, Amroha,
                Uttar Pradesh 244241
              </p>
            </div>

            {/* Phone */}
            <div className="contact-box">
              <a href="tel:+919800040505">
                <PhoneOutlined className="icon" />
                <h3>Call Now</h3>
                <p>+91-9800040505</p>
              </a>
            </div>

            {/* Email */}
            <div className="contact-box">
              <a href="mailto:garvana2112@gmail.com">
                <MailOutlined className="icon email" />
                <h3>Email</h3>
                <p>garvana2112@gmail.com</p>
              </a>
            </div>

            {/* WhatsApp */}
            <div className="contact-box">
              <a
                href="https://wa.me/919800040505"
                target="_blank"
                rel="noopener noreferrer"
              >
                <WhatsAppOutlined className="icon whatsapp" />
                <h3>WhatsApp</h3>
                <p>Chat Now</p>
              </a>
            </div>
          </div>
        </Card>

        {/* Right Side: Contact Form */}
        <Card className="contact-form-card">
          <h2 className="contact-title">Get in Touch</h2>

          <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
            className="contact-form"
          >
            <Form.Item
              name="fullName"
              label="Full Name"
              rules={[{ required: true, message: "Please enter your full name!" }]}
            >
              <Input placeholder="Enter your name" />
            </Form.Item>

            <Form.Item name="company" label="Company/Institution">
              <Input placeholder="Enter your company name" />
            </Form.Item>

            <Form.Item
              name="email"
              label="Email"
              rules={[
                { required: true, type: "email", message: "Please enter a valid email!" },
              ]}
            >
              <Input placeholder="Enter your email" />
            </Form.Item>

            <Form.Item
              name="phone"
              label="Phone Number"
              rules={[{ required: true, message: "Please enter your phone number!" }]}
            >
              <Input placeholder="Enter your phone number" />
            </Form.Item>

            <Form.Item
              name="subject"
              label="Subject"
              rules={[{ required: true, message: "Please enter a subject!" }]}
            >
              <Input placeholder="Enter subject" />
            </Form.Item>

            <Form.Item
              name="message"
              label="Message"
              rules={[{ required: true, message: "Please enter your message!" }]}
            >
              <Input.TextArea rows={4} placeholder="Enter your message" />
            </Form.Item>

            <Button type="primary" htmlType="submit" className="contact-btn">
              Send Request
            </Button>
          </Form>
        </Card>
      </div>
    </div>
  );
}
